export enum OrganizerActivityStatusEnum {
  UNPUBLISHED = 'unpublished',
  PUBLISHED = 'published',
  DRAFT = 'draft',
  CANCELED = 'canceled',
}
